import type { StakeholderRelation } from "../../hooks";

/** 関係性の見せ方。同じデータを軸を変えて並べ替えるだけで、件数は変わらない */
export type RelationViewAxis = "respondent" | "recipient";

export interface GroupedStakeholderRelations {
  /** 軸になる人の氏名 */
  name: string;
  email: string;
  /** その人に紐づく相手側の関係性 */
  relations: readonly StakeholderRelation[];
}

/**
 * 関係性を指定した軸でまとめる。
 *
 * 「回答者から見る」は1人が複数の対象について語る形、「受け取る人から見る」は1人が
 * 複数の回答者から語られる形になる。CS がどちらの抜けを探しているかで見たい向きが変わる。
 */
export function groupStakeholderRelations(
  relations: readonly StakeholderRelation[],
  axis: RelationViewAxis,
): GroupedStakeholderRelations[] {
  const groups = new Map<string, GroupedStakeholderRelations>();
  for (const relation of relations) {
    const email =
      axis === "respondent"
        ? relation.respondentEmail
        : relation.recipientEmail;
    const name =
      axis === "respondent" ? relation.respondentName : relation.recipientName;
    const group = groups.get(email);
    if (group) {
      (group.relations as StakeholderRelation[]).push(relation);
      continue;
    }
    groups.set(email, { name, email, relations: [relation] });
  }
  return [...groups.values()];
}
